import FigurePanelFactory from './FigurePanelFactory';

import ExperimentFactory from './ExperimentFactory';
import AssayFactory from './AssayFactory';
import TemplateFactory from './TemplateFactory';
import ProcessExecutionFactory from './ProcessExecutionFactory';

import PlateExperimentFactory from './PlateExperimentFactory';

import Id from './IdFactory';
//import ExperimentFactory from './ExperimentFactory';
import { PROCESS_EXECUTIONS, TEMPLATES, ASSAYS, EXPERIMENTS, WESTERN_BLOTS, SAMPLE_LAYOUTS, FIGURE_PANELS, DIRECTORIES, getResolvedItemTypeName, FIGURES, PLATE_EXPERIMENTS, PUBLICATIONS } from './RecordTypes';
const factories = {
  [PUBLICATIONS]:(() => ({
    config:{},
    items:{
      figurePanels:{}
    },
    
    authors:{},
  })),

  [FIGURE_PANELS]:FigurePanelFactory,
  [WESTERN_BLOTS]:(() => ({title:'Untitled western blot'})),
  antibodyValidation:(() => ({ target:"", templates:[] })),
  [SAMPLE_LAYOUTS]:(({figurePanelId}) => ({figurePanelId})),
  [DIRECTORIES]:(state, item)=>{
    const { multidim, directoryType } = item;
    return ({children:[], multidim, directoryType })
  },
  [FIGURES]:() => ({ title:'', description:'', panelOrder:[], panels:{} }),
  [TEMPLATES]:TemplateFactory,

  [PROCESS_EXECUTIONS]:ProcessExecutionFactory,

  [EXPERIMENTS]:ExperimentFactory,
  [ASSAYS]:AssayFactory,
  [PLATE_EXPERIMENTS]:PlateExperimentFactory,
}

export default function Factory(state,item){

 
  if( !item ){
    debugger;
  }

  let _id = item._id || Id();
  let { type } = item;

  if( !(type in factories) ){
    throw Error("'"+type + "' is not a registered type.");
  }

  

  let resolvedType = getResolvedItemTypeName(type)

  
  

  let data = {
    _id,
    ...factories[resolvedType](state,item),
    links:{}
  }

  return data;

}
